import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import {Link} from 'react-router-dom'

import Button from './../components/forms/Button'
import FormInput from './../components/forms/FormInput'
import DashAuthWrapper from './../components/DashAuthWrapper'

const mapState = ({ user }) => ({
	currentUser: user.currentUser,
});

const AcctDetails = props => {

	const { currentUser } = useSelector(mapState)

	const [displayName] = useState(currentUser.displayName);
	const [address] = useState(currentUser.address);
	const [address2] = useState(currentUser.address2);
	const [city] = useState(currentUser.city);
	const [state] = useState(currentUser.state);
	const [zip] = useState(currentUser.zip);
	const [phone] = useState(currentUser.phone);
	

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])



	const congfigAuthWrapper = {
		headline: 'Account Details'
	}

	return (
		<DashAuthWrapper {...congfigAuthWrapper}>
		<form className="py-5 mx-auto" >

			<div className="form-group text-left">
				<label htmlFor="displayName">Full Name</label>
				<FormInput 
					type="text" name="displayName" value={displayName} className="form-control" disabled 
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="address">Address</label>
				<FormInput 
					type="text" name="address" value={address} className="form-control" disabled
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="address2">Address2</label>
				<FormInput 
					type="text" name="address2" value={address2} className="form-control" disabled
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="city">City</label>
				<FormInput 
					type="text" name="city" value={city} className="form-control" disabled
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="state">State</label>
				<FormInput 
					type="text" name="state" value={state}  className="form-control" disabled
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="zip">Zip Code</label>
				<FormInput 
					type="number" name="zip" value={zip} className="form-control" disabled
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="phone">Phone</label>
				<FormInput 
					type="number" name="phone" value={phone}  className="form-control" disabled
				/>
			</div>
			<div>
				<Link to="/editAcctDetails">
					<Button className="btn mx-3">
						EDIT
					</Button>
				</Link>
			</div>	
			
		</form>
	</DashAuthWrapper>
	)
}

export default AcctDetails;

